module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In memory of my mother,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gean O’Hara Britt,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded-b"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("who loved to eat in tea rooms")])]), _vm._v(" "), _c('p', {
    staticClass: "img-ns"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "73",
      "src": "images/pgv.jpg",
      "width": "103"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0